export type ReservationEmailSetting =
  | "receiveNewReservationEmails"
  | "receiveUpdatedReservationEmails"
  | "receiveCancelledReservationEmails";

export const reservationEmailSettings = [
  "receiveNewReservationEmails",
  "receiveUpdatedReservationEmails",
  "receiveCancelledReservationEmails",
] as const satisfies readonly ReservationEmailSetting[];
